var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_382_1888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2002 0C12.7288 0.000105788 16.4004 3.67153 16.4004 8.2002C16.4003 10.1053 15.7482 11.8568 14.6582 13.249C14.6745 13.2634 14.6914 13.2774 14.707 13.293L19.707 18.293C20.0975 18.6835 20.0976 19.3165 19.707 19.707C19.3165 20.0976 18.6835 20.0975 18.293 19.707L13.293 14.707C13.2774 14.6914 13.2634 14.6745 13.249 14.6582C11.8568 15.7482 10.1053 16.4003 8.2002 16.4004C3.67153 16.4004 0.000105785 12.7288 0 8.2002C0 3.67146 3.67146 0 8.2002 0ZM8.2002 2C4.77603 2 2 4.77603 2 8.2002C2.00011 11.6243 4.7761 14.4004 8.2002 14.4004C11.6242 14.4003 14.4003 11.6242 14.4004 8.2002C14.4004 4.7761 11.6243 2.00011 8.2002 2Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_382_1888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.030e3d7c285e8640f5a330a9f3e07d19.svg";
export { ForwardRef as ReactComponent };